import type { FC } from 'react';
import { Heading, SkeletonLine } from '@george-labs.com/design-system';

const DEFAULT_PERCENTAGE_WIDTH = 40;

interface Props {
    className?: string;
    percentageWidth?: number;
    'data-cy'?: string;
}

export const HeadingSkeleton: FC<Props> = ({
    className,
    percentageWidth = DEFAULT_PERCENTAGE_WIDTH,
    'data-cy': dataCy,
}) => (
    <Heading className={className} level={2} data-cy={dataCy}>
        <SkeletonLine level={2} percentageWidth={percentageWidth} animated />
    </Heading>
);
